import { Component } from '@angular/core';
import { environment } from '@my-env/environment';
import { CommonServiceService } from '@my-services/common-service.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
 appName = environment.appName;
 envirementName = 'Dev';
 title = 'You using the newest version:';
 isPopOverOpen:boolean = false;
 jsonData: any;
 constructor(
  private commonService: CommonServiceService,
  private toastr: ToastrService,

){}

 ngOnInit(){
  this.loadConfig();
 }
  onPopOverClick(): void {
    this.isPopOverOpen = true;
    setTimeout(() => {
      this.isPopOverOpen = false;
    }, 5000);
  }

  loadConfig() {
    this.commonService.getConfig().subscribe({
      next: config => {
        this.jsonData = config;
      },
      error: err => {
        this.toastr.error(`Error loading config code: ${err.status}`, `Error`);
      },
      complete: () => {
        // console.log('Config loading complete');
      }
    });
  }

}
